import { useCallback, useEffect, useRef, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FilterBar from "./components/FilterBar";
import FeaturedPicks from "./components/FeaturedPicks";
import LatestList from "./components/LatestList";
import MidnightSection from "./components/MidnightSection";
import UncutSection from "./components/UncutSection";
import ClassicsSection from "./components/ClassicsSection";
import Collections from "./components/Collections";
import HowToFind from "./components/HowToFind";
import Footer from "./components/Footer";
import DetailModal from "./components/DetailModal";
import Toast from "./components/Toast";
import type { MovieDetail } from "./types";

export default function Home() {
  const [active, setActive] = useState<MovieDetail | null>(null);
  const [toast, setToast] = useState("");
  const timerRef = useRef<number | null>(null);

  const showToast = useCallback((message: string) => {
    setToast(message);
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setToast(""), 3200);
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  const openDetail = useCallback((movie: MovieDetail) => setActive(movie), []);
  const closeDetail = useCallback(() => setActive(null), []);

  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-background-50">
      <Header />
      <main>
        <Hero onNotify={showToast} />
        <FilterBar onNotify={showToast} />
        <FeaturedPicks onOpen={openDetail} />
        <LatestList onOpen={openDetail} onNotify={showToast} />
        <MidnightSection onOpen={openDetail} />
        <UncutSection onOpen={openDetail} onNotify={showToast} />
        <ClassicsSection onOpen={openDetail} />
        <Collections onNotify={showToast} />
        <HowToFind />
      </main>
      <Footer />
      <DetailModal movie={active} onClose={closeDetail} onNotify={showToast} />
      <Toast message={toast} onClose={() => setToast("")} />
    </div>
  );
}